<template>
  <loading v-if="pageLoading" />

  <div v-else>
    <div
      v-if="allowAdd && userId && table.results.length"
      class="message is-dark"
    >
      <div class="message-body has-padding-75">
        <apart>
          <p>Add a website on behalf of this user.</p>
          <button
            class="button is-dark is-rounded is-outlined"
            @click="addSite"
          >
            Add site
          </button>
        </apart>
      </div>
    </div>

    <data-filter
      v-if="showDataFilter"
      :filters="filters"
      :active-filters="activeFilters"
      @filtersChanged="filtersChanged"
    />

    <b-table
      :data="table.data"
      :mobile-cards="true"
      :default-sort="[table.sort.field, table.sort.direction]"
      :loading="table.loading"
      backend-sorting
      hoverable
      striped
      class="has-vertical-align-middle"
      @sort="onSort"
    >
      <template slot="empty">
        <no-results
          :cta="{ label: 'Add site' }"
          icon="box-open"
          title="No sites"
          message="There are no sites to show."
          @click="addSite"
        />
      </template>

      <template slot-scope="props">
        <b-table-column label="Status" field="isDeleted" width="100">
          <status-label :status="props.row.isDeleted ? 'deleted' : 'active'" />
        </b-table-column>

        <b-table-column label="Site" field="fqdn" sortable>
          <router-link
            :to="{ path: `/sites/magic/${props.row._id}` }"
            class="has-text-dark"
          >
            <strong>
              <u>{{ props.row.fqdn }}</u>
            </strong>
          </router-link>
        </b-table-column>

        <b-table-column
          label="Subscription"
          field="isSubscribed"
          width="150"
          sortable
        >
          <b-icon
            :icon="props.row.isSubscribed ? 'check' : 'times'"
            :type="props.row.isSubscribed ? 'is-success' : 'is-danger'"
            size="is-small"
            class="has-margin-left-25"
          />
        </b-table-column>

        <b-table-column
          label="Tasks"
          field="quota.totalTasks"
          class="has-text-centered"
          width="1"
          >{{
            props.row.quota ? props.row.quota.totalTasks || `–` : `–`
          }}</b-table-column
        >

        <b-table-column
          v-if="userId"
          label="Role"
          field="role"
          sortable
          width="150"
          >{{ getUserRole(props.row) }}</b-table-column
        >

        <b-table-column
          label="Software"
          field="software"
          sortable
          width="150"
          >{{ props.row.software }}</b-table-column
        >

        <b-table-column
          label="Created"
          field="dateCreated"
          sortable
          width="150"
        >
          <span v-if="props.row.dateCreated">{{
            $moment(props.row.dateCreated.toDate()).from()
          }}</span>
        </b-table-column>
      </template>
    </b-table>

    <load-more
      v-if="!table.complete"
      :loading="table.loading"
      @loadMore="getData(true)"
    />
  </div>
</template>

<script>
import { getUserRole } from "@src/services/site";
import { collection, query, where } from "@firebase/firestore";

export default {
  name: "SitesTable",

  mixins: [require("@mixins/table-with-filtering-and-sorting").default],

  props: {
    userId: {
      type: String,
      required: false,
      default: ""
    },
    resellerId: {
      type: String,
      required: false,
      default: ""
    },
    allowAdd: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      pageLoading: true,
      filters: [
        {
          key: "fqdn",
          label: "Site",
          type: "string"
        },
        {
          key: "software",
          label: "Software",
          type: "string"
        },
        {
          key: "dateCreated",
          label: "Created",
          type: "date"
        }
      ]
    };
  },

  methods: {
    getFirestoreRef() {
      let ref = collection(this.$firestore, "sites");
      if (this.userId) {
        ref = query(ref, where("users", "array-contains", this.userId));
      }
      if (this.resellerId) {
        ref = query(ref, where("resellerId", "==", this.resellerId));
      }
      return this.buildFirestoreRef(ref);
    },

    afterDataLoad() {
      this.pageLoading = false;
    },

    getUserRole(site) {
      let role = getUserRole({ site: site, userId: this.userId });

      return role.charAt(0).toUpperCase() + role.slice(1);
    },
    addSite() {
      const modal = this.$modal.open({
        component: () => import("@shared/sites/_addSiteModal"),
        parent: this,
        width: 540,
        hasModalCard: true,
        canCancel: [],
        events: {
          success: siteId => {
            modal.close();
            this.$router.push(`/sites/${siteId}`);
          }
        },
        props: {
          parent: this,
          userId: this.userId
        }
      });
    }
  }
};
</script>
